/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */

/** @type {HtmlExtension} */
export var gfmStrikethroughHtml = {
  enter: {
    strikethrough: function strikethrough() {
      this.tag('<del>');
    }
  },
  exit: {
    strikethrough: function strikethrough() {
      this.tag('</del>');
    }
  }
};